export const appSettings = {
    backend_api : `https://rfid-be.schemaxtech.in/api`,
    APP_IAM_SERVER_URL: "https://ums-backend.shahiapps.in",
    APP_IAM_CLIENT_ID: "225ba80a-3678-4a37-891e-4a55079df157",
}
